import { registerRawHelper } from "discourse/lib/helpers";
import { i18n } from "discourse-i18n";

registerRawHelper("i18n", i18n);

export default i18n;
